export function getBackendBaseUrl() {
  const configuredUrl = import.meta.env.VITE_API_URL;
  if (configuredUrl && String(configuredUrl).trim()) {
    return String(configuredUrl).trim();
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
    // Port 8000 is the local dev FastAPI default — not used in production (Traefik routes by subdomain)
    return `${protocol}//${window.location.hostname}:8000`;
  }

  // Fallback for SSR/test environments — not used in production
  return 'http://127.0.0.1:8000';
}
